import Resource from './Resource';

export default class ClassPageSubPages extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {}
		} = options;

		let subpageType = '';
		if( options.type === 'course' ){
			subpageType = 'subpages';
		}

		if( options.type === 'group' ){
			subpageType = 'student-group-subpages';
		}

		if( options.type === 'student' ){
			subpageType = 'student-subpages';
		}

		let config = {
			route: `class-pages/:courseSectionGuid/${subpageType}/:lineNo`,
			query: query,
			routeParams: routeParams,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
